import type { GoeDeviceSubtype } from 'utils/communication/websocketTypes';

import { useAppSelector } from 'redux-store';

const useDeviceSubtype = (serial?: string): GoeDeviceSubtype | undefined =>
  useAppSelector(
    state =>
      state.devices.items.find(device => device.serial === serial)?.subtype ??
      undefined,
  );

export default useDeviceSubtype;
